////////LIBRARY/////////
import { useEffect, useState } from 'react'
import { cloneDeep, filter, map, isEmpty, isUndefined, find, isEqual } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import { columnsActionCreators, tableActionCreators } from '../../../../store/actions'

function UseColumnsManager(columnsConf, setterMethod, paramTableReferential) {
	// this hook receive 3 params sometimes to prevent error we need to set non use arg, ref: GLPI (2023020007)
	useSelector(
		(state) => ({
			translations: state.languages.translations,
			consignation: state.consignation,
			consignationFilter: state.consignation.header,
			kioskPerimeter: state.user.identity.kioskSelected,
			salesHistoryManager: state.salesHistoryManager.transaction,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			contractSend: state.consignation.contractSend,
			userRolePrivileges: state.user.identity.rolePrivileges,
			cols: state.columns.col,
		}),
		shallowEqual
	)

	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())
	const [columns, setColumns] = useState([])
	const { tableReferential } = useSelector(
		(state) => ({
			tableReferential: find(state.user.tableReferential, { id: paramTableReferential?.idPageTable }),
		}),
		shallowEqual
	)
	const [isActionColumn, setIsActionColumn] = useState(false)

	useEffect(() => {
		const data = map(columnsConf, (column, id) => {
			let visiblity = true
			// Retrieving what column display was stored by user
			if (!isEmpty(tableReferential) && !isUndefined(tableReferential)) {
				tableReferential.columnPreference.forEach((columnReferential) => {
					if (columnReferential.label === column.columnReferential) {
						visiblity = columnReferential.select
					}
				})
			}
			return { ...column, visibility: visiblity }
		})
		setColumns(data)

		if (
			!isEqual(
				filter(columnsConf, (f) => f.action),
				[]
			)
		) {
			setIsActionColumn(true)
		}
	}, [columnsConf])

	// if sonar smell something, leave this part of code as he is
	// in the first refact we apply a patch, but the changes have for effect to avoid possibility to have only one columns display
	// in case of columns actions
	const handleColumnsFilter = (id, labelColumn) => {
		const updateCol = cloneDeep(columns)
		// keep at least 1 column to layout
		if (isActionColumn) {
			if (filter(updateCol, { visibility: true }).length === 2 && updateCol[id].visibility) {
				return
			}
		} else {
			if (filter(updateCol, { visibility: true }).length === 1 && updateCol[id].visibility) {
				return
			}
		}

		updateCol[id].visibility = !updateCol[id].visibility

		// Care, id is index of col. We should probably have something like updateCol[id].idColumn

		// Saving user's display in this table
		actionsTable.setSavedTableColumnsDisplay({
			label: labelColumn,
			select: updateCol[id].visibility,
			idPageTable: paramTableReferential?.idPageTable,
		})

		setColumns(updateCol)
		actionsColumns.setColumns(updateCol)
	}

	return [columns, handleColumnsFilter]
}

export default UseColumnsManager
